import parse from 'html-react-parser'
import type { ReactNode } from 'react'

type PaymentStepProps = {
  icon: ReactNode
  text: string
}

const PaymentStep = ({ icon, text }: PaymentStepProps) => (
  <div className='onboarding-application-info-row'>
    <div className='onboarding-application-info-icon'>{icon}</div>
    <span className='onboarding-application-info-text'>{parse(text)}</span>
  </div>
)

export default PaymentStep
